var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-field__container", class: _vm.containerClass },
    [
      _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-field__container-inner" },
        [
          _vm.icon
            ? _c("NsIcon", {
                staticClass: "inner-icon",
                attrs: { "icon-name": _vm.icon },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "checkbox"
            ? _c(
                "input",
                _vm._g(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputValue,
                        expression: "inputValue",
                      },
                    ],
                    ref: "input",
                    attrs: {
                      id: _vm.id,
                      disabled: _vm.disabled,
                      placeholder: _vm.placeholder,
                      name: _vm.name,
                      "aria-describedby": _vm.id,
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.inputValue)
                        ? _vm._i(_vm.inputValue, null) > -1
                        : _vm.inputValue,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.inputValue,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.inputValue = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.inputValue = $$c
                        }
                      },
                    },
                  },
                  _vm.inputListeners
                )
              )
            : _vm.type === "radio"
            ? _c(
                "input",
                _vm._g(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputValue,
                        expression: "inputValue",
                      },
                    ],
                    ref: "input",
                    attrs: {
                      id: _vm.id,
                      disabled: _vm.disabled,
                      placeholder: _vm.placeholder,
                      name: _vm.name,
                      "aria-describedby": _vm.id,
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.inputValue, null) },
                    on: {
                      change: function ($event) {
                        _vm.inputValue = null
                      },
                    },
                  },
                  _vm.inputListeners
                )
              )
            : _c(
                "input",
                _vm._g(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputValue,
                        expression: "inputValue",
                      },
                    ],
                    ref: "input",
                    attrs: {
                      id: _vm.id,
                      disabled: _vm.disabled,
                      placeholder: _vm.placeholder,
                      name: _vm.name,
                      "aria-describedby": _vm.id,
                      type: _vm.type,
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.inputValue = $event.target.value
                      },
                    },
                  },
                  _vm.inputListeners
                )
              ),
          _vm._v(" "),
          _vm.clearable && _vm.inputValue.length
            ? _c(
                "button",
                { staticClass: "clear-button", on: { click: _vm.clearInput } },
                [
                  _c("NsIcon", {
                    attrs: { "icon-name": "icon-circle-close-light" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      this.$slots.default
        ? _c("div", { staticClass: "helper-text" }, [_vm._t("default")], 2)
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }